module.exports = __webpack_public_path__ + "static/media/adult.593b7c7d.svg";